import { IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  backgroundColor: string;
  highlightColor?: string;
  title: string;
  guideText: string;
  onClick: () => void;
}
export const WelcomeBanner: React.FC<React.PropsWithChildren<Props>> = ({
  backgroundColor,
  highlightColor,
  title,
  guideText,
  onClick,
}) => {
  return (
    <Banner color={highlightColor} backgroundColor={backgroundColor} onClick={onClick}>
      <Text dangerouslySetInnerHTML={{ __html: title }} />
      <More>
        <GuideText dangerouslySetInnerHTML={{ __html: guideText }} />
        <IconArrowRightBold
          size={16}
          v3Color={'pink300'}
          style={{ margin: '0 0 0 1px', ...(highlightColor && { color: highlightColor }) }}
        />
      </More>
    </Banner>
  );
};

const Banner = styled.div<{ color?: string; backgroundColor: string }>`
  margin: 0 16px 16px 16px;
  padding: 0 12px 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  border-radius: 6px;
  background-color: ${({ backgroundColor }) => backgroundColor};

  ${({ color }) =>
    color &&
    `      
      font {
        color: ${color};
      }
  `};
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${vars.v3Color.staticWhite};
`;

const More = styled.div`
  display: flex;
  align-items: center;
`;

const GuideText = styled.div`
  font-size: 13px;
  font-weight: 600;
`;
